export const accordionMetaData = {
    isRepeatable: false
}
